require('./externalTransferFundView.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const {
    Component
} = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const { formatText, getFinalTitle } = require('core/i18n').i18n;
// @ actions
const externalTransferFundActions = require('actions/externalTransferFund');
const advancedSearchActions = require('actions/brokerAdvancedSearch');
const brokerStocksByTypeActions = require('actions/brokerStocksByType');
const brokerFundLegalDocumentActions = require('actions/brokerFundLegalDocument');
const brokerStocksByContractActions = require('actions/brokerWallets');
const BrokerCustomWalletLoaderActions = require('customWallets/actions/brokerCustomWalletLoader');
const profile = require('actions/profile');
const {
    sendBrokerPreContractualMail,
    resetPrecontractualMail
} = require('actions/contactCenter/preContractualMailInfo/preContractualMailInfo');
const printerActions = require('actions/contactCenter/printer');
const brokerConvenienceMiFIDTestActions = require('mifid/actions/brokerConvenienceMiFIDTest');
// @ commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
// @ components
const ExternalTransferFund = require('components/hireInvestmentFunds/externalTransferFund/externalTransferFund/externalTransferFund');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ constants
const { MYPROFILE_BROKER_URL } = require('constants/index');
// @utils
const { scrollToTop } = require('commonsUtilities/scrollUtils');

class ExternalTransferFundView extends Component {
    constructor(props) {
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.handleShowHelp = this.handleShowHelp.bind(this);
        this.handleHideHelp = this.handleHideHelp.bind(this);
        this.handleRetry = this.handleRetry.bind(this);
    }

    componentDidMount() {
        const { immSearchState, getStocksByType, getFilters } = this.props;

        getStocksByType();
        if (!immSearchState.get('allProductsFiltersFetched')) {
            getFilters();
        }
        scrollToTop();
    }

    buildHeader(showingHelp) {

        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('breadcrumb-brokerExternalTransferFund')
            }
        ];
        const titleKey = showingHelp
            ? 'brokerExternalTransferFundStep1-help'
            : 'brokerExternalTransferFundStep1-title';
        const subtitle = showingHelp
            ? formatText('brokerExternalTransferFundStep1-title')
            : formatText('brokerExternalTransferFundStep1-title2');
        return (
            <OKCover size="medium" section="broker" customClass="col-xs-12">
                <OKHeaderSubPage
                    breadcrumbConfig={mappingBreadcrumb}
                    subtitleLeft={subtitle}
                    isSubtitleLeftCapital={false}
                    finalTitle={getFinalTitle(titleKey)}>
                </OKHeaderSubPage>
            </OKCover>
        );
    }

    handleCancel() {
        this.props.history.push(MYPROFILE_BROKER_URL);
    }

    handleFinish() {
        this.props.confirmationTransfer(this.props.history);
    }

    handleShowHelp() {
        this.props.showHelp();
    }

    handleHideHelp() {
        this.props.hideHelp();
    }

    handleRetry() {
        this.props.getWalletData(this.props.getStocksByType);
    }

    render() {
        const {
            setVisibleStep,
            validateStep,
            setWillCancel,
            immExternalTransferFund,
            handleInputSearchProductSelected,
            handleResetSearchProductSelected,
            handleSetSearchProductSelected,
            setInstitutionName,
            setAccount,
            setNif,
            setHasNif,
            immBrokerMyInvestments,
            setType,
            setSubtype,
            setAmount,
            setDestinationFund,
            setCheckbox,
            getOriginFund,
            getInterveners,
            postValidation,
            immAccounts,
            immBrokerFundLegalDocument,
            immFundsList,
            fetchLegalDocuments,
            immProfileFields,
            requestProfile,
            immPreContractualMail,
            sendBrokerPreContractualMail,
            resetPrecontractualMail,
            setLegalInformationConf,
            resetLegalInformation,
            resetAmountDirty,
            setDocumentsRead,
            getStocksContracts,
            resetPrintedIndicators,
            history,
        } = this.props;

        const header = this.buildHeader(immExternalTransferFund.get('showingHelp'));

        if (immExternalTransferFund.get('isFetching')) {
            return <LoadingSection />;
        }

        return (
            <div>
                <div className="container-fluid external-transfer-fund-view--header-identifier">
                    <div className="row">
                        {header}
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <ExternalTransferFund
                                immProfileFields={__CONTACT_CENTER__ ? immProfileFields : undefined}
                                requestProfile={__CONTACT_CENTER__ ? requestProfile : undefined}
                                immPreContractualMail={__CONTACT_CENTER__ ? immPreContractualMail : undefined}
                                sendPreContractualMail={__CONTACT_CENTER__ ? sendBrokerPreContractualMail : undefined}
                                resetPrecontractualMail={__CONTACT_CENTER__ ? resetPrecontractualMail : undefined}
                                immAccounts={immAccounts}
                                immBrokerFundLegalDocument={immBrokerFundLegalDocument}
                                immFundsList={immFundsList}
                                validateStep={validateStep}
                                setVisibleStep={setVisibleStep}
                                setWillCancel={setWillCancel}
                                onCancel={this.handleCancel}
                                onFinish={this.handleFinish}
                                onHandleRetry={this.handleRetry}
                                immExternalTransferFund={immExternalTransferFund}
                                handleInputSearchProductSelected={handleInputSearchProductSelected}
                                handleResetSearchProductSelected={handleResetSearchProductSelected}
                                handleSetSearchProductSelected={handleSetSearchProductSelected}
                                setInstitutionName={setInstitutionName}
                                setAccount={setAccount}
                                setNif={setNif}
                                setHasNif={setHasNif}
                                immBrokerMyInvestments={immBrokerMyInvestments}
                                setType={setType}
                                setSubtype={setSubtype}
                                setAmount={setAmount}
                                setDestinationFund={setDestinationFund}
                                setCheckbox={setCheckbox}
                                resetAmountDirty={resetAmountDirty}
                                getOriginFund={getOriginFund}
                                getInterveners={getInterveners}
                                postValidation={postValidation}
                                fetchLegalDocuments={fetchLegalDocuments}
                                onHideHelp={this.handleHideHelp}
                                reset={this.props.reset}
                                setLegalInformationConf={__CONTACT_CENTER__ ? setLegalInformationConf : undefined}
                                resetLegalInformation={__CONTACT_CENTER__ ? resetLegalInformation : undefined}
                                onStartMifid={this.props.onStartMifid}
                                onCancelMifid={(externalTransferFundStateBeforeMifid) => this.props.onCancelMifid(externalTransferFundStateBeforeMifid, history)}
                                onResetMifid={this.props.onResetMifid}
                                setDocumentsRead={setDocumentsRead}
                                getStocksContracts={getStocksContracts}
                                resetPrintedIndicators={resetPrintedIndicators}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ExternalTransferFundView.propTypes = {
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    resetPrintedIndicators: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    requestProfile: PropTypes.func.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    reset: PropTypes.func.isRequired,
    resetAmountDirty: PropTypes.func.isRequired,
    setWillLeave: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    immBrokerFundLegalDocument: PropTypes.object.isRequired,
    immFundsList: PropTypes.object.isRequired,
    immExternalTransferFund: PropTypes.object.isRequired,
    immSearchState: PropTypes.object.isRequired,
    handleInputSearchProductSelected: PropTypes.func.isRequired,
    handleResetSearchProductSelected: PropTypes.func.isRequired,
    handleSetSearchProductSelected: PropTypes.func.isRequired,
    setInstitutionName: PropTypes.func.isRequired,
    setAccount: PropTypes.func.isRequired,
    setNif: PropTypes.func.isRequired,
    setHasNif: PropTypes.func.isRequired,
    getStocksByType: PropTypes.func.isRequired,
    setType: PropTypes.func.isRequired,
    setSubtype: PropTypes.func.isRequired,
    setAmount: PropTypes.func.isRequired,
    setDestinationFund: PropTypes.func.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    setCheckbox: PropTypes.func.isRequired,
    setLegalInformationConf: PropTypes.func.isRequired,
    resetLegalInformation: PropTypes.func.isRequired,
    getOriginFund: PropTypes.func.isRequired,
    getFilters: PropTypes.func.isRequired,
    getStocksContracts: PropTypes.func.isRequired,
    getWalletData: PropTypes.func.isRequired,
    getInterveners: PropTypes.func.isRequired,
    postValidation: PropTypes.func.isRequired,
    confirmationTransfer: PropTypes.func.isRequired,
    showHelp: PropTypes.func.isRequired,
    hideHelp: PropTypes.func.isRequired,
    onStartMifid: PropTypes.func.isRequired,
    onCancelMifid: PropTypes.func.isRequired,
    sendBrokerPreContractualMail: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    fetchLegalDocuments: PropTypes.func.isRequired,
    onResetMifid: PropTypes.func.isRequired,
    setDocumentsRead: PropTypes.func.isRequired,
};

module.exports.constructor = ExternalTransferFundView;

module.exports.ExternalTransferFundView = connect(state => ({
    immAccounts: state.accounts,
    immProfileFields: state.profile,
    immExternalTransferFund: state.externalTransferFund,
    immSearchState: state.brokerSearch,
    immBrokerMyInvestments: state.brokerMyInvestments,
    immPreContractualMail: state.preContractualMail,
    immBrokerFundLegalDocument: state.brokerFundLegalDocument,
    immFundsList: state.brokerWallets.get('fundsList')
}), {
    validateStep: externalTransferFundActions.validateStep,
    resetPrintedIndicators: printerActions.resetPrintedIndicators,
    setVisibleStep: externalTransferFundActions.setVisibleStep,
    setWillCancel: externalTransferFundActions.setWillCancel,
    setWillLeave: externalTransferFundActions.setWillLeave,
    reset: externalTransferFundActions.reset,
    resetAmountDirty: externalTransferFundActions.resetAmountDirty,
    setInstitutionName: externalTransferFundActions.setInstitutionName,
    setAccount: externalTransferFundActions.setAccount,
    setNif: externalTransferFundActions.setNif,
    setHasNif: externalTransferFundActions.setHasNif,
    setType: externalTransferFundActions.setType,
    setSubtype: externalTransferFundActions.setSubtype,
    setAmount: externalTransferFundActions.setAmount,
    setDestinationFund: externalTransferFundActions.setDestinationFund,
    handleInputSearchProductSelected: externalTransferFundActions.selectOriginFund,
    handleSetSearchProductSelected: externalTransferFundActions.setOriginFund,
    handleResetSearchProductSelected: externalTransferFundActions.resetOriginFund,
    setLegalInformationConf: externalTransferFundActions.setLegalInformationConf,
    resetLegalInformation: externalTransferFundActions.resetLegalInformation,
    getStocksByType: brokerStocksByTypeActions.getStocksByType,
    setCheckbox: externalTransferFundActions.setCheckbox,
    getOriginFund: externalTransferFundActions.getOriginFund,
    getFilters: advancedSearchActions.getFilters,
    getInterveners: externalTransferFundActions.getInterveners,
    postValidation: externalTransferFundActions.checkPostValidation,
    getStocksContracts: brokerStocksByContractActions.getWalletList,
    getWalletData: BrokerCustomWalletLoaderActions.getWalletData,
    confirmationTransfer: externalTransferFundActions.confirmationTransfer,
    showHelp: externalTransferFundActions.showHelp,
    hideHelp: externalTransferFundActions.hideHelp,
    onStartMifid: externalTransferFundActions.startMifid,
    onCancelMifid: externalTransferFundActions.cancelMifid,
    requestProfile: profile.requestProfile,
    sendBrokerPreContractualMail: sendBrokerPreContractualMail,
    resetPrecontractualMail: resetPrecontractualMail,
    fetchLegalDocuments: brokerFundLegalDocumentActions.fetchLegalDocuments,
    onResetMifid: brokerConvenienceMiFIDTestActions.reset,
    setDocumentsRead: externalTransferFundActions.setDocumentsRead,
})(withRouter(ExternalTransferFundView));
